'use client';

import { __styles, mergeClasses } from '@griffel/react';
export const skeletonClassNames = {
  root: 'fui-Skeleton'
};
const useStyles = /*#__PURE__*/__styles({
  blockStyling: {
    mc9l5x: "ftgm304"
  }
}, {
  d: [".ftgm304{display:block;}"]
});
/**
 * Apply styling to the Skeleton slots based on the state
 */
export const useSkeletonStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(skeletonClassNames.root, state.root.as === 'span' && styles.blockStyling, state.root.className);
  return state;
};